import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { EUserType } from 'src/app/domain/enum/user-type';
import { ENavigationRoute } from 'src/app/model/enum/navigation-route';
import { UserService } from 'src/app/services/user.service';
import { CoreData } from 'src/app/tools/core-data/core-data';

@Component({
    selector: 'app-redirect',
    templateUrl: './redirect.component.html',
    styleUrl: './redirect.component.scss'
})
export class RedirectComponent implements OnInit {
    constructor(
        private snackBar: MatSnackBar,
        private router: Router,
        private route: ActivatedRoute,
        private userService: UserService,
        private oauthService: OAuthService,
        private coreData: CoreData) { }

    ngOnInit() {

        this.oauthService.events.subscribe(x => {
            if (x.type === 'token_received')

                setTimeout(async () => {

                    // Get the roles and permissions
                    await new Promise((resolve, reject) => {
                        this.userService.getRole().subscribe((x: EUserType) => {
                            this.coreData.UserType = x;
                            resolve(true);
                        });
                    });

                    // redirect to your default page.
                    if (this.coreData.UserType === EUserType.Standard)
                        this.router.navigate([ENavigationRoute.SampleList]);
                    else
                        this.router.navigate([ENavigationRoute.Home]);
                }, 1000)
        })
    }
}
